// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**quicklinks css starts**/
.quickNavContent ul > li {
  padding: 10px 10px 10px 0;
}

.quickNavContent ul > li > a {
  font-family: "montserratregular", Arial, Helvetica, sans-serif;
  color: #767676;
  cursor: pointer;
}

.quickNavContent ul > li > a:hover {
  color: #36f;
}

/**quicklinks css ends**/`, "",{"version":3,"sources":["webpack://./src/app/system-common/navigation-links/navigation-links.component.scss"],"names":[],"mappings":"AAAA,0BAAA;AACA;EACE,yBAAA;AACF;;AACA;EACE,8DAAA;EACA,cAAA;EACA,eAAA;AAEF;;AAAA;EACE,WAAA;AAGF;;AADA,wBAAA","sourcesContent":["/**quicklinks css starts**/\r\n.quickNavContent ul > li {\r\n  padding: 10px 10px 10px 0;\r\n}\r\n.quickNavContent ul > li > a {\r\n  font-family: 'montserratregular', Arial, Helvetica, sans-serif;\r\n  color: #767676;\r\n  cursor: pointer;\r\n}\r\n.quickNavContent ul > li > a:hover {\r\n  color: #36f;\r\n}\r\n/**quicklinks css ends**/\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
